import React from 'react';
import TableLink from "v4/components/utils/TableLink/TableLink";
import MoveTaskButton from "v4/features/front/moveTask/components/MoveTaskButton/MoveTaskButton";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import useListingRowActionsRoute from "v4/hooks/useListingRowActionsRoute";

export default function TasksListingRowActions({ rowId, prospectId, isClosed, isMailing, isSynchroOutlook }) {
    const route = useListingRowActionsRoute([
        { identifier: 'detail_mail_history', condition: isMailing, },
        { identifier: 'detail_received_mails', condition: isSynchroOutlook },
        { identifier: 'detail_closed_tasks', condition: isClosed },
        { identifier: 'detail_open_tasks', condition: true }
    ]);

    return (
        <>
            <TableLink href={`/${resolveUrl(route.url, { prospect: prospectId })}/${rowId}`}/>
            <ul className="table-actions">
                <li><MoveTaskButton taskId={rowId}/></li>
            </ul>
        </>
    )
}
